// @ts-strict-ignore
import React, { useContext } from 'react';
import { Text } from '@usealloy/component-library';
import { RuleBuilderContext } from '../../context';
import isEmpty from 'lodash/isEmpty';
import { isActionOfType } from 'flow/service/actions';
import { ActionType } from 'flow/store/engine/constants';
import { StyledRuleClause } from './styles';
import { selectOutcomeActions } from 'flow/store/redux/selectors';
import { useAppSelector } from '~/store/reduxHooks';

/* Component that renders "if", "else if", "else" text that precedes rules */
export default function RuleClause() {
  const outcomeActions = useAppSelector(selectOutcomeActions);
  const { sourceAction, isPreviewOutcome, containerType } = useContext(RuleBuilderContext);

  const isEmptyPreviewOutcome = isPreviewOutcome && isEmpty(sourceAction.rules);

  const shouldRenderElseIf = isActionOfType(sourceAction, ActionType.OUTCOME)
    && sourceAction.outcome.precedenceIndex > 1
    && sourceAction.outcome.precedenceIndex < outcomeActions.length;

  return (
    <StyledRuleClause
      isEmptyPreviewOutcome={isEmptyPreviewOutcome}
      containerType={containerType}
    >
      {shouldRenderElseIf ? 'Else if' : 'If'}
      {isEmptyPreviewOutcome && (
        <Text style={{ display: 'inline-flex', color: 'rgba(0, 0, 0, 0.5)' }}>
          &nbsp;(link threshold by clicking a node in the map)
        </Text>
      )}
    </StyledRuleClause>
  );
}
